import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber, CountryCode } from 'libphonenumber-js/min';

@Pipe({
    name: 'phone',
    standalone: false
})

export class PhonePipe implements PipeTransform {
    transform(phoneValue: number | string, country: string): any {
        try {
            if (!country) {
                country = "US";
            }
            phoneValue = phoneValue + '';

            if (country == 'MX') {
                if (phoneValue.indexOf('52') == 0) {
                    phoneValue = phoneValue.substr(2, phoneValue.length - 2);
                }

                if (phoneValue.indexOf('01152') == 0) {
                    phoneValue = phoneValue.substr(5, phoneValue.length - 5);
                }                
            }

            const phoneNumber = parsePhoneNumber(phoneValue, country as CountryCode);

            return country == 'MX'
                ? phoneNumber.formatInternational()
                : phoneNumber.formatNational();
        } catch (error) {
            return phoneValue;
        }
    }
}
